import countriesData from '../config/countries.json';
import settingsData from '../config/settings.json';
import { Country } from '../types';

export interface AppSettings {
  defaultCountryId: number;
  supportedImageFormats: string[];
  maxFileSize: number;
  processingSettings: {
    demoMode: boolean;
    debugMode: boolean;
  };
  app: {
    name: string;
    version: string;
    mode: string;
  };
}

export const configService = {
  getCountries: (): Country[] => {
    return countriesData.countries;
  },

  getSettings: (): AppSettings => {
    return settingsData;
  },

  getDefaultCountry: (): Country | null => {
    const settings = configService.getSettings();
    const countries = configService.getCountries();
    return countries.find(c => c.id === settings.defaultCountryId) || null;
  },

  isBackendMode: (): boolean => {
    const settings = configService.getSettings();
    return settings.app.mode !== 'frontend-only';
  },

  getAppInfo: () => {
    const settings = configService.getSettings();
    return {
      name: settings.app.name,
      version: settings.app.version,
      mode: settings.app.mode,
      isDemo: settings.processingSettings.demoMode
    };
  }
};